// communityProviderStore.js (ESB-636)
import { defineStore } from 'pinia'
import { computed, inject, ref } from 'vue'
import axios from 'axios'
import { BACKEND_BASEURL } from '@/config/config'

/**
 * Community providers (CP): So-Strom internal grouping of community companies
 * for service fee billing, admin only endpoints.
 */
export const useCommunityProviderStore = defineStore('communityProviderStore', () => {
  const $log = inject('log')

  const providers = ref([])
  const providersLoading = ref(false)

  const allProviders = computed(() => providers.value)
  const providerById = computed(() => new Map(providers.value.map(p => [p._id, p])))

  async function fetchProviders() {
    providersLoading.value = true
    try {
      const response = await axios.get(BACKEND_BASEURL + 'communityProvider')
      providers.value = response.data
      return response.data
    } catch (error) {
      $log?.warn('fetch communityProviders failed', error)
      throw error
    } finally {
      providersLoading.value = false
    }
  }

  async function createProvider(providerData) {
    const response = await axios.post(BACKEND_BASEURL + 'communityProvider', providerData)
    providers.value.push(response.data)
    return response.data
  }

  async function updateProvider(id, providerData) {
    const response = await axios.put(BACKEND_BASEURL + 'communityProvider/' + id, providerData)
    const index = providers.value.findIndex(p => p._id === id)
    if (index !== -1) providers.value[index] = response.data
    return response.data
  }

  async function deleteProvider(id) {
    await axios.delete(BACKEND_BASEURL + 'communityProvider/' + id)
    providers.value = providers.value.filter(p => p._id !== id)
  }

  async function assignCompany(id, ecn) {
    const response = await axios.put(BACKEND_BASEURL + 'communityProvider/' + id + '/company/' + ecn)
    return response.data
  }

  async function unassignCompany(ecn) {
    const response = await axios.delete(BACKEND_BASEURL + 'communityProvider/company/' + ecn)
    return response.data
  }

  return {
    providers,
    providersLoading,
    allProviders,
    providerById,
    fetchProviders,
    createProvider,
    updateProvider,
    deleteProvider,
    assignCompany,
    unassignCompany,
  }
})
